module.exports = __webpack_public_path__ + "static/media/3.623cd1af.ogg";